export default () => ({
  attrFormatter: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    paddingLeft: 20
  },
  dateTimeFormatter: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    paddingLeft: 20
  }
});